<template>
        <select-two
            style="border-radius: 6px"
            class="block form-select focus:outline-none"
            :class="{'hide-arrow': selectedAnswer}"
            v-model="selectedAnswer"
            :options="options"
            placeholder="Select an answer"
            searchPlaceholder="Type to search"
            :settings="{ width: '100%', templateResult: templateResult }"
            :style="{
                        backgroundColor: modelValue?.bg_color,
                        borderTopColor: modelValue?.bg_color,
                        color: modelValue?.text_color
                    }"
        >
        </select-two>
</template>

<script>
import {computed} from "vue";
import SelectTwo from '@/Components/SelectTwo';

export default {
    name: "SurveyAnswerPicker",
    components: {
        SelectTwo
    },
    props: {
        answers: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: Object,
            default: null
        },
        preview: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue','select'],
    setup(props, {emit}) {
        const options = props.answers.map((option, index) => {
            return {
                id: index,
                text: option.value + (option.label ? ' - ' + option.label : ''),
                bg_color: option.bg_color,
                text_color: option.text_color,
            }
        })
        const selectedAnswer = computed({
            get: () => {
                const replyIndex = props.answers.findIndex((answer) => answer.id === props.modelValue?.id);

                if (replyIndex === -1) {
                    return null;
                }

                return replyIndex.toString();
            },
            set: (value) => {
                emit('update:modelValue', props.answers[value])
            },
        });

        const templateResult = (data, container) => {
            if (data.element) {
                container.style['background-color'] = data.bg_color;
                container.style.color = data.text_color;
            }
            return data.text;
        };

        return {
            selectedAnswer,
            options,
            templateResult,
        }
    }
}
</script>

<style>

</style>
